$(window).on('load', function() {
    mmenuInit();
});

/*--------------------------------------------------*/
/*  Mobile Menu - mmenu.js
/*--------------------------------------------------*/
function mmenuInit() {
    var wi = $(window).width();
    if(wi <= '1024') {

        $(".mmenu-init" ).remove();
        $("#mmenu-navigation").clone().addClass("mmenu-init").insertBefore("#mmenu-navigation").removeAttr('id').removeClass('style-1 style-2')
            .find('ul, div').removeClass('style-1 style-2 mega-menu mega-menu-content mega-menu-section').removeAttr('id');
        $(".mmenu-init").find("ul").addClass("mm-listview");
        $(".mmenu-init").find(".mobile-styles .mm-listview").unwrap();


        $(".mmenu-init").mmenu({
            "counters": true
        }, {
            // configuration
            offCanvas: {
                pageNodetype: "#wrapper"
            }
        });

        $(".nav-sub-menu.active a").click();
        var mmenuAPI = $(".mmenu-init").data( "mmenu" );
        var $icon = $(".hamburger");

        $(".mmenu-trigger").click(function() {
            if ($(".mmenu-trigger").find('.is-active').length) {
                mmenuAPI.close();
            } else {
                mmenuAPI.open();
            }
        });

        var is_inside = false;

        $( ".mmenu-init" ).on( "mouseenter", function() {
            is_inside=true;
        });
        $( ".mmenu-init" ).on( "mouseleave", function() {
            is_inside=false;
        });

        $('div:not(.mmenu-init)').mouseup(function(){
            if(! is_inside) mmenuAPI.close();
        });

        mmenuAPI.bind( "open:finish", function() {
            setTimeout(function() {
                $icon.addClass( "is-active" );
            });
        });
        mmenuAPI.bind( "close:finish", function() {
            setTimeout(function() {
                $icon.removeClass( "is-active" );
            });
        });

        $('body').swipe({
            swipe:function(event, direction) {
                if ($(".mmenu-trigger").find('.is-active').length) {
                    if (direction === "left") {
                        mmenuAPI.close();
                    }
                }
            }
        });
    }

    $(".mm-next").addClass("mm-fullsubopen");
}

$(window).resize(function() { mmenuInit(); });

